import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ColumnDefinition } from "tabulator-tables";
import { Users } from "../../API/Users";
import ReusableModal from "../../components/ReusableModal";
import Tabulator from "../../components/Tabulator";

// const trMachine1 = process.env.REACT_APP_TR_MACHINE_ONE;
// const trMachine2 = process.env.REACT_APP_TR_MACHINE_TWO;
export default function TileSessions() {
  const userAPI = useMemo(() => new Users(), []);

  //#region - SESSION
  const [sessionData, setSessionData] = useState<any>(null);
  useEffect(() => {
    try {
      userAPI.sessions().then((response) => {
        let normalizedData = normalizeSessions(response);
        let ids: any = Object.keys(normalizedData);
        ids = ids.map((item: string) => Number(item));

        userAPI
          .fetchUserProperties(["firstName", "lastName", "level", "group"], ids)
          .then((res) => {
            const _data = res.data.rows;
            for (let i = 0; i < _data.length; i++) {
              let temp = _data[i];
              temp = { ...temp, ...normalizedData[temp.id] };
              _data[i] = temp;
            }
            setSessionData(_data);
          });
      });
    } catch (error) {}
  }, [userAPI]);
  //#endregion

  const [showDetails, setShowDetails] = useState(false);
  const onClickDetail = useCallback(() => {
    setShowDetails(true);
  }, []);

  // const modalContent = useMemo(() => {
  //   const columns: ColumnDefinition[] = [
  //     { title: "ID", field: "id", widthGrow: 1 },
  //     { title: "Client", field: "group", widthGrow: 2 },
  //     {
  //       title: "First name",
  //       field: "firstName",
  //       hozAlign: "left",
  //       widthGrow: 2,
  //     },
  //     { title: "Last name", field: "lastName", hozAlign: "left", widthGrow: 2 },
  //     { title: "Type", field: "level", hozAlign: "left", widthGrow: 2 },
  //     {
  //       title: "Sessions on N" + trMachine1,
  //       field: "trMachine1",
  //       hozAlign: "center",
  //       widthGrow: 1,
  //     },
  //     {
  //       title: "Sessions on N" + trMachine2,
  //       field: "trMachine2",
  //       hozAlign: "center",
  //       widthGrow: 1,
  //     },
  //     {
  //       title: "Total sessions",
  //       field: "total",
  //       hozAlign: "center",
  //       widthGrow: 1,
  //     },
  //   ];
  //   return (
  //     <Box display={"flex"} height={"100%"}>
  //       <Tabulator
  //         layout="fitDataStretch"
  //         data={sessionData}
  //         columns={columns}
  //       />
  //     </Box>
  //   );
  // }, [sessionData]);

  const modalContent = useMemo(() => {
    const columns: ColumnDefinition[] = [
      { title: "ID", field: "id", widthGrow: 1 },
      { title: "Client", field: "group", widthGrow: 2 },
      {
        title: "First name",
        field: "firstName",
        hozAlign: "left",
        widthGrow: 2,
      },
      { title: "Last name", field: "lastName", hozAlign: "left", widthGrow: 2 },
      { title: "Type", field: "level", hozAlign: "left", widthGrow: 2 },
    ];

    let machines: string[] = [];
    if (sessionData && sessionData.length > 0) {
      sessionData.forEach((item: any) => {
        const keys = Object.keys(item).filter((k) => k.startsWith("tr"));
        keys.forEach((k) => {
          if (!machines.includes(k)) {
            machines.push(k);
          }
        });
      });
      machines.forEach((machine) => {
        columns.push({
          title: machine,
          field: machine,
          hozAlign: "center",
          widthGrow: 1,
        });
      });

      if (machines.length > 0) {
        columns.push({
          title: "Total sessions",
          field: "totalSessions",
          hozAlign: "center",
          widthGrow: 1,
          formatter: (cell, formatterParams, onRendered) => {
            const rowData = cell.getRow().getData();
            let total: number = 0;
            machines.forEach((machine) => {
              total += rowData[machine] ? rowData[machine] : 0;
            });
            return total.toString();
          },
        });
      }
    }

    return (
      <Box display={"flex"} height={"100%"}>
        <Tabulator
          layout="fitDataStretch"
          data={sessionData}
          columns={columns}
        />
      </Box>
    );
  }, [sessionData]);

  return (
    <Box p={1} boxShadow={3} borderRadius={2}>
      <Typography display={"flex"} gap={2} alignItems={"center"}>
        <strong>{sessionData ? sessionData.length : 0}</strong> Active users
        <IconButton color="secondary" size="small" onClick={onClickDetail}>
          <InfoIcon />
        </IconButton>
      </Typography>

      <ReusableModal
        isOpen={showDetails}
        children={modalContent}
        modalTitle={<Typography>Active users</Typography>}
        setIsOpen={() => setShowDetails(false)}
      />
    </Box>
  );
}

const normalizeSessions = (response: any) => {
  const data = response.data;
  const dictionary: any = {};
  data.forEach((item: any) => {
    const userId = item.userId;
    const node = item.node;
    if (!dictionary[userId]) {
      const nodeObj: any = {};
      nodeObj[node] = 1;
      dictionary[userId] = nodeObj;
    } else {
      if (!dictionary[userId][node]) {
        dictionary[userId][node] = 1;
      } else {
        dictionary[userId][node] += 1;
      }
    }
  });
  return dictionary;
};

// const normalizeSessions = (response: any) => {
//   let raw: any = response.data;
//   let data: any = {};
//   let trMachine1 = process.env.REACT_APP_TR_MACHINE_ONE;
//   let trMachine2 = process.env.REACT_APP_TR_MACHINE_TWO;
//   var pattern1 = "trapp" + trMachine1 + "|trtest" + trMachine1  ;
//   var pattern2 = "trapp" + trMachine2 + "$|trtest" + trMachine2 ;
//   var pattern3 =
//     "trapp" +
//     trMachine1 +
//     "|trapp" +
//     trMachine2 +
//     "|trtest" +
//     trMachine1 +
//     "|trtest" +
//     trMachine2;
//   var test1 = null;
//   var test2 = null;
//   var test3 = null;
//   var record = null;
//   for (var i = 0, length = raw.length; i < length; i++) {
//     record = raw[i];
//     if (!(record.userId in data)) {
//       data[record.userId] = {
//         trMachine1: 0,
//         trMachine2: 0,
//         total: 0,
//       };
//     }

//     test1 = new RegExp(pattern1, "gi");
//     test2 = new RegExp(pattern2, "gi");
//     test3 = new RegExp(pattern3, "gi");

//     if (test1.test(record.node)) {
//       data[record.userId].trMachine1++;
//     }

//     if (test2.test(record.node)) {
//       data[record.userId].trMachine2++;
//     }

//     if (test3.test(record.node)) {
//       data[record.userId].total++;
//     }
//   }
//   return data;
// };
